import { render, staticRenderFns } from "./Click.vue?vue&type=template&id=562b6f95&"
import script from "./Click.vue?vue&type=script&lang=js&"
export * from "./Click.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports